<template>
    <nav class="bg-primary-color">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <div class="border-b border-gray-700">
                <div class="flex items-center justify-between h-16 px-4 sm:px-0">
                    <div class="flex items-center">
                        <div class="flex-shrink-0">
                            <img class="h-8 w-auto" src="/img/logo.png" alt="Valley Co-op Oil Mill">
                        </div>
                        <div class="hidden md:block">
                            <div class="ml-10 flex items-baseline space-x-4">
                                <inertia-link :href="route('dashboard')"
                                              class="px-3 py-2 rounded-md text-sm font-medium text-white bg-primary-color">
                                    Dashboard
                                </inertia-link>

                                <inertia-link :href="route('settings.news')"
                                              class="px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:text-white hover:bg-gray-700">
                                    Settings
                                </inertia-link>
<!--
                                <inertia-link :href="route('import')"
                                              class="px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:text-white hover:bg-gray-700">
                                    Import Files
                                </inertia-link>
-->
                                <inertia-link :href="route('users')"
                                              class="px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:text-white hover:bg-gray-700">
                                    Users
                                </inertia-link>
                            </div>
                        </div>
                    </div>
                    <div class="hidden md:block">
                        <div class="ml-4 flex items-center md:ml-6">

                            <!-- Profile dropdown -->
                            <div class="ml-3 relative">
                                <div class="flex items-center">
                                    <span class="text-blue-100 text-sm mr-2">{{  $page.props.auth.user.name }}</span>
                                    <button @click="showUserMenu = !showUserMenu" class="max-w-xs bg-gray-800 rounded-full flex items-center text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white" id="user-menu" aria-haspopup="true">
                                        <span class="sr-only">Open user menu</span>
                                        <svg class="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clip-rule="evenodd"></path></svg>
                                    </button>
                                </div>

                                <div v-show="showUserMenu" class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5" role="menu" aria-orientation="vertical" aria-labelledby="user-menu">
                                    <inertia-link :href="route('users.profile', $page.props.auth.user.id)" class="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 text-center" role="menuitem">Your Profile</inertia-link>
                                    <inertia-link class="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" :href="route('logout')" as="button" method="post">Logout</inertia-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="-mr-2 flex md:hidden">
                        <!-- Mobile menu button -->
                        <button type="button" class="bg-gray-800 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                            <span class="sr-only">Open main menu</span>
                            <svg v-show="!showMobileMenu" @click="showMobileMenu = true" class="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                            <svg v-show="showMobileMenu" @click="showMobileMenu = false" class="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="showMobileMenu" class="border-b border-gray-700 md:hidden">
            <div class="px-2 py-3 space-y-1 sm:px-3">
                <inertia-link :href="route('dashboard')"
                              class="block px-3 py-2 rounded-md text-base font-medium text-white bg-primary-color">
                    Dashboard
                </inertia-link>

                <inertia-link :href="route('settings.news')"
                              class="block px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-white hover:bg-gray-700">
                    Settings
                </inertia-link>

                <inertia-link :href="route('import')"
                              class="block px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-white hover:bg-gray-700">
                    Upload
                </inertia-link>

                <inertia-link :href="route('users')"
                              class="block px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-white hover:bg-gray-700">
                    Users
                </inertia-link>
            </div>
            <div class="pt-4 pb-3 border-t border-gray-700">
                <div class="flex items-center px-5">
                    <div class="flex-shrink-0">
                        <svg class="w-10 h-10" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clip-rule="evenodd"></path></svg>
                    </div>
                    <div class="ml-3">
                        <div class="text-base font-medium leading-none text-white">{{ $page.props.auth.user.name }}</div>
                        <div class="text-sm font-medium leading-none text-gray-400">{{ $page.props.auth.user.email }}</div>
                    </div>
                </div>
                <div class="mt-3 px-2 space-y-1">
                    <inertia-link :href="route('users.profile', $page.props.auth.user.id)" class="block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700" role="menuitem">Your Profile</inertia-link>
                    <inertia-link class="block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700" :href="route('logout')" as="button" method="post">Logout</inertia-link>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    data() {
        return {
            showUserMenu: false,
            showMobileMenu: false,
        }
    },
}
</script>
